export const CelebrateIcon = () => <p className="p-p">🎉</p>;
